// Generated by GitHub Copilot
import React, { useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Spinner, Alert } from "react-bootstrap";
import ImpactView from "./ImpactView";
import useProblemData from "../../hooks/useProblemData";
// eslint-disable-next-line no-unused-vars
import { LightModeLayout } from "../Layout/LightModeLayout";

/**
 * ImpactViewPage - Route wrapper for the Impact Command Center
 * Fetches problem data and renders the ImpactView component
 * Route: /problem/impact/:id
 */
function ImpactViewPage({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  // Generated by GitHub Copilot
  // eslint-disable-next-line no-unused-vars
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  // Generated by GitHub Copilot - US1812367: Use ref to track modal state without causing re-fetches
  const isReportModalOpenRef = useRef(false);

  // Use custom hook for problem data fetching with auto-refresh
  // Generated by GitHub Copilot - Refresh only when modal is closed
  const { loading, error, problemData } = useProblemData(id, {
    autoRefresh: true,
    shouldRefresh: () => !isReportModalOpenRef.current,
  });

  const handleBack = () => {
    // Navigate back to the problem viewer
    navigate(`/problem/view/${id}`);
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading problem data...</span>
        </Spinner>
        <p className="mt-3">Loading Impact Command Center...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">
          <Alert.Heading>Error Loading Problem</Alert.Heading>
          <p>{error}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-danger"
              onClick={() => navigate("/problems")}
            >
              Go to Problems List
            </button>
          </div>
        </Alert>
      </Container>
    );
  }

  if (!problemData) {
    return (
      <Container className="py-5">
        <Alert variant="warning">
          <Alert.Heading>Problem Not Found</Alert.Heading>
          <p>The requested problem could not be found.</p>
          <hr />
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-warning"
              onClick={() => navigate("/problems")}
            >
              Go to Problems List
            </button>
          </div>
        </Alert>
      </Container>
    );
  }

  // Guard: impact reporting is not available for temporary problems
  if (problemData.temporary) {
    return (
      <Container className="py-5">
        <Alert variant="info" data-testid="impact-unavailable-alert">
          <Alert.Heading>Impact Reporting Unavailable</Alert.Heading>
          <p>
            Impact reporting is not available for temporary problems. A
            ServiceNow Problem (PRB) record must be created first.
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-info"
              onClick={handleBack}
              data-testid="impact-back-button"
            >
              Back to Problem
            </button>
          </div>
        </Alert>
      </Container>
    );
  }

  // Extract outage data from first outage in array

  return (
    <LightModeLayout>
      <ImpactView
        problemNumber={problemData.number}
        problemTitle={problemData.short_description || "No Description"}
        priority={problemData.priority || "EP4"}
        onBack={handleBack}
        user={user}
        onReportModalChange={setIsReportModalOpen}
      />
    </LightModeLayout>
  );
}

export default ImpactViewPage;
